import React from 'react';

const NoAccountFunctionality = () => {
    return (
        <div>Sorry, your user account or API key does not have the roles required to access any functionality provided by the Emulate portal.</div>
    );
};

export default NoAccountFunctionality;
